<template>

    <div class="col-lg-5">


        <div class="product__header">
            <div class="prodcut__gallery">
                <div class="gallery">
                    <div class="gallery__slides">
                        <div class="gallery__slide">
                                <picture v-for="(data_imgs,index) in data_img.value">
                                    <source v-bind:srcset="'../storage/photos/'+data_imgs.path_webp" type="image/webp">
                                    <source v-bind:srcset="'../storage/photos/'+data_imgs.path" type="image/png">
                                    <img class="gallery__img"
                                         width="470"
                                         height="470"
                                         v-bind:src="'../storage/photos/'+data_imgs.path"
                                         :alt="data_imgs.alt_photo"
                                         :title="data_imgs.title_photo"
                                         :key="index"
                                          @click="showmodel(slide.path)"
                                        :style="slideShowIndex === index ? 'display:block;' : 'display:none;'"
                                     >
                            </picture>
                        </div>

                    </div>
                    <span @click="move(+1)" class="gallery__prev">&#10094;</span>
                    <span @click="move(-1)" class="gallery__next">&#10095;</span>
                    <div class="gallery__content">
                        <div class="gallery__items">

                                <div class="gallery__item" v-for="(data_imgs,index) in data_img.value" :key="`item-${index}`">
                                    <picture>
                                        <source v-bind:srcset="'../storage/photos/'+data_imgs.path_webp" type="image/webp">
                                        <source v-bind:srcset="'../storage/photos/'+data_imgs.path" type="image/png">
                                        <img class="gallery__item-img" :class="{'gallery__item--is-acitve': slideShowIndex === index}" @click="currentSlide(index)"  width="90"  height="90" :src="'../storage/photos/'+data_imgs.path" :alt="data_imgs.alt_photo" :title="data_imgs.title_photo" >
                                    </picture>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modala" v-show="isShowingModel">
        <div class="modal__content">
            <span  @click="closeModel" class="modal__close" ><i class="fa fa-close"></i></span>
            <div  class="modal__body"  @focusout="closeModel" >
                <img :src="modelImg" class="show__gallery">
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive,ref} from 'vue'
    import axios from 'axios'

    export default {
        name: "SliderGallery",
        props: ['slugg'],
        setup(props) {
           // const slug = ref(props.slugg);
            const data_img = reactive([]);
            const getImg = async() => {

                    axios.get('/api/slider/' + props.slugg )
                    .then(res => {
                        data_img.value=res.data;
                    }).catch(err =>{
                    console.log(err);
                })

            }
            getImg();


                const slideShowIndex=ref(0);
                const isShowingModel=ref(false);
                const modelImg=ref(null);


            const move = (n) =>
                {

                    if (data_img.value.length <= slideShowIndex.value + n) {
                        slideShowIndex.value = 0;
                    } else if (slideShowIndex.value + n < 0) {
                       slideShowIndex.value = (data_img.value.length - 1);
                    } else {
                        slideShowIndex.value += n;
                    }

                };

            const  currentSlide = (index) =>
                {
                    slideShowIndex.value = index;
                };

              const  showmodel =(img) =>
                {
                    isShowingModel.value = true;
                    modelImg.value = img;
                    document.body.style.overflow = 'hidden'
                };

                const closeModel =() =>
                {
                    console.log('document.body.style.overflow=\'hidden\'')
                    isShowingModel.value = false;
                    document.body.style.overflow = 'unset'
                };
               return {
                   closeModel,
                   showmodel,
                   currentSlide,
                   move,
                   slideShowIndex,
                   isShowingModel,
                   modelImg,
                   data_img,


            };

            }
    }
</script>

<style scoped>

</style>
